export default "__VITE_ASSET__CH6H67oM__"